module.exports = __webpack_public_path__ + "static/media/Actor.8ec4a4de.jpg";